/* TASK-1623 free shipping add-on: the Add button in the cart drawer.
   Delegated on document because cart-items.js replaces #cart-promoted-products innerHTML
   on every cart change, so a listener bound to the button itself would die after one re-render. */
(function () {
  if (window.lrCartFreeshipBound) return;
  window.lrCartFreeshipBound = true;

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('.js-lr-fs-add');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed ' + res.status);
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      try {
        var b = await fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); });
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && b['cart-icon-bubble']) {
          var t = document.createElement('template');
          t.innerHTML = b['cart-icon-bubble'];
          var el = t.content.querySelector('.shopify-section');
          if (el) bubble.innerHTML = el.innerHTML;
        }
      } catch (err) { /* bubble count is cosmetic */ }
    } catch (err) {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      console.error('[lr-cart-freeship]', err); // eslint-disable-line
    }
  });
})();
